import styled from "styled-components";

export const WebAppsSitesDescriptionWrapper = styled.div``;

export const WebAppsSitesOl = styled.ol`
  padding: 10px 25px;
  margin: 0;
  list-style-type: lower-alpha;
`;
